import { filter, sumBy } from 'lodash';

// Counts active vulnerability scanners (outposts) across the given accounts.
// Extracted for VulnerabilityOverview so the "N Outposts" label reflects real data.
export const getActiveScannerCount = (
  scannerInfo: Record<string, { status?: string | null }[]> | null | undefined,
  accountIds: string[],
): number =>
  sumBy(
    accountIds,
    id => filter(scannerInfo?.[id], o => o.status === 'Active').length,
  );
